import src from "IMAGE";
export default { src, width: 320, height: 325, blurWidth: 0, blurHeight: 0};
